import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
export function PlatformProducts() {
  const products = [{
    name: 'CJI Core',
    desc: 'The flagship civic-judgment and decision-quality platform'
  }, {
    name: 'NCJI Youth',
    desc: 'Developmental capability architecture for childhood through secondary education'
  }, {
    name: 'NCJI Pathways',
    desc: 'A framework for university, vocational, and workforce readiness, upward mobility, and opportunity guidance'
  }, {
    name: 'NCJI Civic',
    desc: 'A general public layer for civic capability, misinformation resilience, and decision-quality strengthening'
  }, {
    name: 'NCJI Service',
    desc: 'A public-sector and civil-service readiness framework'
  }, {
    name: 'NCJI Executive',
    desc: 'A leadership-readiness and governance diagnostic environment for senior officials and high-responsibility roles'
  }, {
    name: 'NCJI Atlas',
    desc: 'A regional and national dashboard for capability mapping, resilience analysis, and strategic planning'
  }];
  return <section className="py-20 lg:py-28 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto border-t border-line" data-id="element-500">
      <div className="max-w-3xl mb-12" data-id="element-501">
        <span className="text-xs font-semibold text-navy-light uppercase tracking-[0.2em] mb-4 block" data-id="element-502">
          Product Stack
        </span>
        <h2 className="text-3xl md:text-4xl font-heading font-bold text-ink-dark mb-6" data-id="element-503">
          The SyNeural ecosystem
        </h2>
        <p className="text-lg text-ink-muted leading-relaxed" data-id="element-504">
          The platform is organized as a modular ecosystem that allows
          deployment across different stages of life, organizational settings,
          and levels of responsibility.
        </p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4" data-id="element-505">
        {products.map((product, index) => <motion.div key={product.name} initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.4,
        delay: index * 0.05
      }} className="bg-surface-card p-6 rounded-lg border border-line shadow-sm hover:border-navy/30 hover:shadow-md transition-all flex flex-col h-full group cursor-pointer" data-id="element-506">
            <h3 className="text-lg font-heading font-bold text-navy mb-2" data-id="element-507">
              {product.name}
            </h3>
            <p className="text-sm text-ink-muted mb-6 flex-grow" data-id="element-508">
              {product.desc}
            </p>
            <div className="flex items-center text-sm font-medium text-teal group-hover:text-navy transition-colors mt-auto" data-id="element-509">
              Learn More{' '}
              <ArrowRight size={14} className="ml-1 transform group-hover:translate-x-1 transition-transform" data-id="element-510" />
            </div>
          </motion.div>)}
      </div>
    </section>;
}